import requests from "./request";


  // 左右两侧信息
  export function queryIndexData() {
    return requests({
      url: '/large-screen/queryIndexData',
      method: 'get',
      headers: {
        // 'X-Access-Token':window.sessionStorage.getItem("token")
      },
    })
  }
  export function queryBuildingTypeSimpleDataList() {
    return requests({
      url: '/large-screen/queryBuildingTypeSimpleDataList?isBuildingType=' +true,
      method: 'get',
      headers: {
        // 'X-Access-Token':window.sessionStorage.getItem("token")
      },
    })
  }
  // 首页信息侧数据
  export function querySurveyTableListForScreen(data) {
    return requests({
      url: '/large-screen/querySurveyTableListForScreen',
      method: 'post',
      headers: {
      },
      data
    })
  }
  // 弹窗详情
  export function querySurveyRecoredById(surveyTableId) {
    return requests({
      url: '/large-screen/querySurveyRecoredById?surveyTableId=' +surveyTableId,
      method: 'get',
      headers: {
        // 'X-Access-Token':window.sessionStorage.getItem("token")
      },
    })
  }
  // 查询风险等级下拉数据列表
  export function querySimpleDataListForRiskLevel() {
    return requests({
      url: '/large-screen/querySimpleDataListForRiskLevel',
      method: 'get',
      headers: {
        // 'X-Access-Token':window.sessionStorage.getItem("token")
      },
    })
  }
  // 查询灾害类型下拉数据列表
  export function querySimpleDataListForDisasterType() {
    return requests({
      url: '/large-screen/querySimpleDataListForDisasterType',
      method: 'get',
      headers: {
        // 'X-Access-Token':window.sessionStorage.getItem("token")
      },
    })
  }

  // 风险弹窗列表
  export function queryAreaInfoList(data) {
    return requests({
      url: '/large-screen/queryAreaInfoList',
      method: 'post',
      headers: {
      },
      data
    })
  }

   // 历史灾害弹窗列表
   export function queryDisasterHistoryList(data) {
    return requests({
      url: '/large-screen/queryDisasterHistoryList',
      method: 'post',
      headers: {
      },
      data
    })
  }

  // 主体类型列表
  export function getBuildInfoChartData() {
    return requests({
      url: '/large-screen/getBuildInfoChartData',
      method: 'get',
      headers: {
      },
    })
  }
  // 历史灾害列表
  export function getDisasterHistoryChartDataData() {
    return requests({
      url: '/large-screen/getDisasterHistoryChartData',
      method: 'get',
      headers: {
      },
    })
  }
  // 首页信息侧数据
  export function queryBuildingInfoByDistance(data) {
    return requests({
      url: '/large-screen/queryBuildingInfoByDistance',
      method: 'post',
      headers: {
      },
      data
    })
  }
  // 减灾能力统计数据
  export function queryJianzainengli(data) {
    return requests({
      url: '/large-screen/queryJianzainengli',
      method: 'post',
      headers: {
      },
      data
    })
  }

  // 查询所有乡镇列表
  export function queryDivisionInfoList() {
    return requests({
      url: '/large-screen/queryDivisionInfoList',
      method: 'get',
      headers: {
      },
    })
  }


  // 查询乡镇详情数据
  export function queryDivisionInfo(divId) {
    return requests({
      url: '/large-screen/queryDivisionInfo?divId='+divId,
      method: 'get',
      headers: {
      },
    })
  }